/* RVA: mobile product-media scroll bar.
   Shows a scroll-position progress bar under the product image on mobile, tracking the
   horizontal scroll of the main media slider (.main-image .slider). Ported from the Avision
   theme's av-media-scroll-bar.js, minus the mix-blend-mode styling. Event-delegation-free
   but re-runs on shopify:section:load so it survives theme-editor re-renders. */
function initRvaMediaScrollBars() {
  document.querySelectorAll('[data-rva-media-scroll-bar]').forEach(function (bar) {
    if (bar.dataset.scrollBarInitialized) return;

    var scope = bar.closest('.main-image') || bar.closest('media-gallery');
    var list = scope && scope.querySelector('.slider');
    var thumb = bar.querySelector('.rva-media-scroll-bar__thumb');
    if (!list || !thumb) return;

    bar.dataset.scrollBarInitialized = 'true';

    var update = function () {
      var scrollableWidth = list.scrollWidth - list.clientWidth;
      var trackWidth = bar.clientWidth;
      var thumbWidth = scrollableWidth > 0
        ? Math.max((list.clientWidth / list.scrollWidth) * trackWidth, 24)
        : trackWidth;
      var maxThumbTravel = trackWidth - thumbWidth;
      var progress = scrollableWidth > 0 ? list.scrollLeft / scrollableWidth : 0;

      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + (progress * maxThumbTravel) + 'px)';
      thumb.style.visibility = 'visible';
    };

    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    if (window.ResizeObserver) {
      var observer = new ResizeObserver(update);
      observer.observe(list);
      observer.observe(bar);
    }

    list.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', update, { once: true });
      }
    });

    update();
    requestAnimationFrame(update);
    setTimeout(update, 250);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRvaMediaScrollBars);
} else {
  initRvaMediaScrollBars();
}

document.addEventListener('shopify:section:load', initRvaMediaScrollBars);
